import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import stageIcon from "../../Assets/Images/mnt-podsused-logo.png";
import LoaderBox from "./LoaderBox";

const HomeChampionship = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hideDataMode, setHideDataMode] = useState(false);

  // Funkcija za dohvat podataka
  const fetchBracket = async () => {
    const { data: settings } = await supabase
      .from("site_settings")
      .select("hide_data_mode")
      .eq("id", 1)
      .maybeSingle();
    if (settings) setHideDataMode(settings.hide_data_mode || false);
    const { data, error } = await supabase
      .from("matches")
      .select(
        `
        *,
        team_a:team_a_id(name),
        team_b:team_b_id(name)
      `,
      )
      .eq("group_name", "Završnica");

    if (error) console.error("Greška pri dohvatu:", error);
    else setMatches(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchBracket();

    // REALTIME PRETPLATA: Slušaj promjene u tablici matches
    const subscription = supabase
      .channel("championship_changes")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "matches" },
        () => {
          fetchBracket(); // Ponovno dohvati podatke čim se nešto promijeni
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(subscription);
    };
  }, []);

  // Pomoćna funkcija za izvlačenje utakmice prema slotu
  const getMatch = (slotId) => {
    // Ako je sakrivanje upaljeno, odmah vrati prazan slot s upitnicima
    if (hideDataMode) {
      return {
        team_a: { name: "?" },
        team_b: { name: "?" },
        scorea: 0,
        scoreb: 0,
      };
    }

    const match = matches.find((m) => m.bracket_slot_id === slotId);
    return (
      match || {
        team_a: { name: "?" },
        team_b: { name: "?" },
        scorea: 0,
        scoreb: 0,
      }
    );
  };

  // Logika za prikaz pobjednika turnira (Slot 15 je finale)
  const getWinner = () => {
    if (hideDataMode) return "?"; // Sakrij pobjednika ako je upaljen hideDataMode

    const finale = matches.find((m) => m.bracket_slot_id === 15);
    if (!finale || !finale.is_completed) return "?";
    if (finale.scorea > finale.scoreb) return finale.team_a?.name;
    if (finale.scoreb > finale.scorea) return finale.team_b?.name;
    return "?";
  };

  if (loading) return <LoaderBox text="Učitavanje završnice..." />;

  return (
    <div className="championship-wrapper">
      <div className="championship-stage-header">
        <img src={stageIcon} alt="Stage" className="stage-img" />
        <h3>Završnica Turnira</h3>
      </div>

      <div className="championship-scroll">
        {/* 1. STUPAC: Šesnaestina (Slotovi 1-8) */}
        <div className="championship-column stage-0">
          <h4 className="stage-title">Osmina finala</h4>
          <div className="matches-grid">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((id) => {
              const m = getMatch(id);
              return (
                <div key={id} className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "?"}</span>
                    <span className="score">{m.scorea}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "?"}</span>
                    <span className="score">{m.scoreb}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* 2. STUPAC: Osmina (Slotovi 9-12) */}
        <div className="championship-column stage-1">
          <h4 className="stage-title">ČETVRTFINALE</h4>
          <div className="matches-grid">
            {[9, 10, 11, 12].map((id) => {
              const m = getMatch(id);
              return (
                <div key={id} className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "?"}</span>
                    <span className="score">{m.scorea}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "?"}</span>
                    <span className="score">{m.scoreb}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })}
          </div>
        </div>
        {/* 3. STUPAC: Polufinale (Slotovi 13-14) */}
        <div className="championship-column stage-2">
          <h4 className="stage-title">Polufinale</h4>
          <div className="matches-grid">
            {[13, 14].map((id) => {
              const m = getMatch(id);
              return (
                <div key={id} className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "?"}</span>
                    <span className="score">{m.scorea}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "?"}</span>
                    <span className="score">{m.scoreb}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })}
          </div>
        </div>
        {/* 4. STUPAC: Finale (Slot 15) */}
        <div className="championship-column stage-3 final-stage">
          <h4 className="stage-title">Finale</h4>
          <div className="final-content-wrapper">
            {(() => {
              const m = getMatch(15);
              return (
                <div className="championship-match finale-box">
                  <div className="team">
                    <span>{m.team_a?.name || "?"}</span>
                    <span className="score">{m.scorea}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "?"}</span>
                    <span className="score">{m.scoreb}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })()}

            <div className="trophy-container">
              <img src={stageIcon} alt="Stage" className="stage-img" />
              <h3>POBJEDNIK</h3>
              <div className="winner-box">{getWinner()}</div>
            </div>
          </div>{" "}
          {/* 3. MJESTO */}
          <div className="absolute-third-place">
            <span className="mini-title">ZA 3. MJESTO</span>
            {(() => {
              const m = getMatch(16);
              return (
                <div className="championship-match">
                  <div className="team">
                    <span>{m.team_a?.name || "?"}</span>
                    <span className="score">{m.scorea}</span>
                  </div>
                  <div className="team">
                    <span>{m.team_b?.name || "?"}</span>
                    <span className="score">{m.scoreb}</span>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>{" "}
      </div>

      <div className="scroll-hint">
        <div className="line"></div>
        <span>Povuci za faze</span>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default HomeChampionship;
